<template>
  <div class="headline-with-icon" :class="'theme-' + theme">
    <SvgIcon :name="icon" aria-hidden="true" />
    <Heading tag="h2" role="display" size="small" :content="headline" />
  </div>
</template>

<script>
import './HeadlineWithIcon.scss';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';
import Heading from 'ewi-ui/components/1-atoms/Heading';
export default {
  name: 'HeadlineWithIcon',
  components: {
    SvgIcon,
    Heading,
  },

  props: {
    icon: {
      type: String,
      default: 'info',
    },
    headline: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
};
</script>
